import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MessageCircle, Send } from "lucide-react";

const COR_AUTOR = {
  cliente: "bg-[#FFF7ED] border-[#FDBA74]",
  montador: "bg-[#EFF6FF] border-[#93C5FD]",
  empresa: "bg-[#F0FDF4] border-[#86EFAC]",
  montadora: "bg-[#FAF5FF] border-[#D8B4FE]",
  central: "bg-[#FFF7E0] border-[#F5C518]",
  admin: "bg-[#F4F4F5] border-[#D4D4D8]",
};
const LABEL_AUTOR = { cliente: "Cliente", montador: "Montador", empresa: "Loja", montadora: "Montadora", central: "Central", admin: "MontaJá" };

export const ChatServico = ({ listar, enviar, titulo = "Chat do atendimento", meuTipo, somenteLeitura = false }) => {
  const [msgs, setMsgs] = useState([]);
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);
  const fimRef = useRef(null);

  const load = () => listar().then(setMsgs).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 12000);
    return () => clearInterval(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fimRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs.length]);

  const mandar = async () => {
    const t = texto.trim();
    if (!t || enviando) return;
    setEnviando(true);
    try {
      await enviar(t);
      setTexto("");
      load();
    } catch (e) { /* toast handled by caller apis */ }
    setEnviando(false);
  };

  return (
    <div className="border border-border rounded-lg bg-white" data-testid="chat-servico">
      <div className="px-4 py-2.5 border-b border-border flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-muted-foreground">
        <MessageCircle size={14} /> {titulo}
        <span className="ml-auto font-normal normal-case text-[10px]">Registrado para sua segurança</span>
      </div>
      <div className="max-h-64 overflow-y-auto p-3 space-y-2">
        {msgs.length === 0 && <div className="text-xs text-muted-foreground text-center py-4">Nenhuma mensagem ainda. Fale por aqui — tudo fica registrado.</div>}
        {msgs.map(m => (
          <div key={m.id} className={`border rounded-lg px-3 py-2 text-sm max-w-[85%] ${COR_AUTOR[m.autor_tipo] || COR_AUTOR.admin} ${m.autor_tipo === meuTipo ? "ml-auto" : ""}`}
            data-testid={`chat-msg-${m.id}`}>
            <div className="text-[10px] font-bold text-muted-foreground">
              {LABEL_AUTOR[m.autor_tipo] || m.autor_tipo} · {m.autor_nome} · {new Date(m.em).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
            </div>
            <div className="whitespace-pre-wrap">{m.texto}</div>
          </div>
        ))}
        <div ref={fimRef} />
      </div>
      {somenteLeitura ? (
        <div className="p-2.5 border-t border-border text-[11px] text-muted-foreground text-center" data-testid="chat-somente-leitura">
          🔒 Atendimento encerrado — histórico disponível apenas para consulta.
        </div>
      ) : (
      <div className="p-2.5 border-t border-border flex gap-2">
        <Input value={texto} onChange={e => setTexto(e.target.value)}
          onKeyDown={e => e.key === "Enter" && mandar()}
          placeholder="Escreva sua mensagem…" className="h-9 text-sm" data-testid="chat-input" />
        <Button size="sm" className="h-9" onClick={mandar} disabled={enviando || !texto.trim()} data-testid="chat-enviar">
          <Send size={15} />
        </Button>
      </div>
      )}
    </div>
  );
};

export const fmtDataBR = (iso) => {
  if (!iso) return "—";
  const d = new Date(String(iso).slice(0, 10) + "T12:00:00");
  if (isNaN(d)) return iso;
  const semana = d.toLocaleDateString("pt-BR", { weekday: "long" });
  return `${d.toLocaleDateString("pt-BR")} — ${semana}`;
};
